import React from "react";
import AnimatedLines from "./AnimatedLines";
import "./index.css";

function SwapVideo({ webm, mov, className, onLoadedData, ...rest }) {
  return (
    <video
      className={className}
      autoPlay
      muted
      playsInline
      {...(onLoadedData ? { onLoadedData } : {})}
      {...rest}
    >
      <source src={mov} type="video/quicktime" />
      <source src={webm} type="video/webm" />
      Your browser does not support the video tag.
    </video>
  );
}

export default function App() {
  return (
    <div className="App relative h-screen overflow-visible bg-[#0C1D2B] p-0 m-0 text-center font-brand flex flex-col md:flex-row items-center justify-center">
      {/* Top video */}
      <div className="absolute left-1/2 top-[10px] -translate-x-1/2 bg-[#0C1D2B] max-w-[40%] md:max-w-[17%]">
        <SwapVideo
          className="top-video h-auto max-w-full shadow-none"
          webm="https://nova-web-bucket-he3.s3.us-east-1.amazonaws.com/top_alpha.webm"
          mov="https://nova-web-bucket-he3.s3.us-east-1.amazonaws.com/Top_1.mov"
        />
      </div>

      {/* Mobile: Knight at top */}
      <div className="flex md:hidden w-full justify-start px-4 pt-20 pb-2">
        <SwapVideo
          className="h-auto object-contain" style={{ width: "var(--knight-mobile-w)" }}
          webm="https://nova-web-bucket-he3.s3.us-east-1.amazonaws.com/knight_alpha.webm"
          mov="https://nova-web-bucket-he3.s3.us-east-1.amazonaws.com/knight.mov"
        />
      </div>

      {/* Center block */}
      <div className="flex flex-col md:flex-row items-start md:items-center h-auto w-[90%] md:w-auto px-4 md:px-0 md:gap-1">
        <div className="hidden md:flex items-center justify-center pb-8 shrink-0" style={{ width: "var(--knight-desktop-w)" }}>
          <SwapVideo className="h-auto w-full object-contain" 
            webm="https://nova-web-bucket-he3.s3.us-east-1.amazonaws.com/knight_alpha.webm"
            mov="https://nova-web-bucket-he3.s3.us-east-1.amazonaws.com/knight.mov"
          />
        </div>

        {/* Right column */}
        <div className="flex flex-col items-start text-left flex-1 min-w-0">
          {/* NOVA title — max width 120px */}
          <SwapVideo
            className="h-auto object-contain"
            style={{ width: "var(--nova-title-w)", maxWidth: "100%" }}
            webm="https://nova-web-bucket-he3.s3.us-east-1.amazonaws.com/nova_alpha.webm"
            mov="https://nova-web-bucket-he3.s3.us-east-1.amazonaws.com/nova.mov"
          />
          <div className="h-[15px] w-px" />
          <div className="w-full" style={{ width: "var(--copy-w)" }}>
            <AnimatedLines
              className="font-brand text-white font-light block w-full whitespace-normal break-words"
              style={{ fontSize: "var(--body-fs)", lineHeight: "var(--body-lh)" }}
              text={
                "Nova Global is a venture investment management company. " +
                "Nova partners with out-of-distribution founders building enduring technology companies."
              }
              tailItems={[
                <div className="flex flex-row flex-wrap gap-5 w-full mt-5 mb-5" key="links" style={{ fontSize: "var(--body-fs)" }}>
                  <a
                    href="mailto:contact@novaglobal.com"
                    className="contact-link font-brand text-white no-underline transition-opacity duration-300 hover:opacity-70 cursor-default"
                  >
                    Email →
                  </a>
                  <a
                    href="https://www.linkedin.com/company/nova-global-llc/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="contact-link font-brand text-white no-underline transition-opacity duration-300 hover:opacity-70 cursor-default"
                  >
                    LinkedIn →
                  </a>
                </div>,
                <p
                  className="m-0 font-brand text-white font-light w-full break-words"
                  style={{ fontSize: "var(--body-fs)", lineHeight: "var(--body-lh)" }}
                  key="address"
                >
                  San Francisco&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  <strong>View Tower 10th Floor</strong>
                </p>,
              ]}
            />
          </div>
        </div>
      </div>

      {/* Bottom flourish + copyright */}
      <div className="absolute bottom-[10px] left-1/2 -translate-x-1/2 mb-5 max-w-[80%] md:max-w-[17%]">
        <div className="flex items-center justify-center">
          <SwapVideo
            className="h-auto max-w-full shadow-none"
            webm="https://nova-web-bucket-he3.s3.us-east-1.amazonaws.com/bottom_alpha.webm"
            mov="https://nova-web-bucket-he3.s3.us-east-1.amazonaws.com/bottom.mov"
          />
        </div>
        <div className="copyright-div absolute bottom-0 left-1/2 w-full -translate-x-1/2 flex items-center justify-center">
          <p className="copyright-text m-0 max-w-full min-w-full font-brand text-[#F5F5F0] opacity-60 text-[10px] font-normal">
            ©Nova Copyright, 2025
          </p>
        </div>
      </div>
    </div>
  );
}
